import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

// Full-width top banner shown when a new service-worker version is waiting.
// Tapping it posts SKIP_WAITING; index.js listens for controllerchange
// and reloads the app once the new SW takes over.
export const UpdateBanner = () => {
  const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const on = () => setReady(true);
    window.addEventListener("zavi-sw-update-ready", on);
    return () => window.removeEventListener("zavi-sw-update-ready", on);
  }, []);

  if (!ready) return null;

  const update = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const reg = await navigator.serviceWorker?.getRegistration();
      if (reg?.waiting) {
        reg.waiting.postMessage("SKIP_WAITING");
      } else {
        window.location.reload();
      }
    } catch {
      window.location.reload();
    }
  };

  return (
    <button
      onClick={update}
      className="fixed top-0 inset-x-0 z-[80] bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-[11px] sm:text-xs py-2.5 px-4 flex items-center justify-center gap-2 hover:bg-[#F3D059] transition-colors shadow-md"
      data-testid="sw-update-banner"
      aria-live="polite"
    >
      <RefreshCw size={13} className={busy ? "animate-spin" : ""} />
      {busy ? "Updating…" : "Important: New Version Available. Tap to Update."}
    </button>
  );
};
